import { Stack, Typography } from '@mui/material';

export interface SummaryRowProps {
  label: string;
  value: string;
}

/**
 * Label/value row used in the "current state" cards of the billing
 * screens (current plan, current credit line). Label on the left in
 * muted text, value on the right in bold.
 */
export const SummaryRow = ({ label, value }: SummaryRowProps) => (
  <Stack direction="row" justifyContent="space-between" spacing={2}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={600}>
      {value}
    </Typography>
  </Stack>
);
